import { Box, Modal, Typography } from '@material-ui/core';

const InfoModal = ({ open, handleClose }: { open: boolean; handleClose: () => void }) => {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box css={style}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          League Live currently uses data point Commencement of Construction to track installs, but your scoring and
          compensation have been moved to the data point Install Date.
        </Typography>
        <Typography id="modal-modal-description">
          Until League Live is updated you may see slightly different data here than in your other reports.
        </Typography>
      </Box>
    </Modal>
  );
};

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  padding: 32,
};

export default InfoModal;
